'use strict';

var i18nUtils = require('js/i18nUtils');

// Supported validations:
//   ["pattern", "required", "minLength", "maxLength", "length", "format", "type", "except", "minimum", "maximum", "maxItems", "minItems", "divisibleBy", "uniqueItems", "enum"]
// Example string:
//   {{property}} must be an {{attributeValue}}. Well, {{propertyValue}} does not look like an email

/**
 * Define all the alias to be globally replaced on validation messages here.
 * Maybe could be defined in Config.js file
 */
var alias = function(property) {
  switch (property.toLowerCase()) {
    case 'groupcode':
    case 'subdomain':
      return i18n('Community');
    case 'message':
      return i18n('message');
    case 'supportboxbody':
    case 'formattedbody':
    case 'body':
      return i18n('body');
    case 'supportboxheading':
    case 'title':
      return i18n('title');
    case 'subject':
      return i18n('subject');
    case 'formatteddescription':
    case 'description':
      return i18n('description');
    case 'contactnumber':
      return i18n('telephone');
    case 'concept':
      return i18n('concept');
    case 'condition':
      return i18n('condition');
    case 'formattedname':
    case 'name':
      return i18n('name');
    case 'password':
      return i18n('password');
    case 'supportlink':
      return i18n('link');
    case 'campaignname':
      return i18n('Campaign name');
    case 'calltoactiontext':
      return i18n('Call to action');
    case 'calltoactionurl':
      return i18n('URL');
    case 'snippet':
      return i18n('Text');
    default:
      return property;
  }
};

module.exports = {
  required: function(property) {
    return i18nUtils.sprintf(i18n('%1$s is required.'), alias(property));
  },
  minLength: function(property, propertyValue, attributeValue) {
    return i18nUtils.sprintf(i18n('Given %1$s must be at least %2$s characters long.'), alias(property), attributeValue);
  },
  maxLength: function(property, propertyValue, attributeValue) {
    return i18nUtils.sprintf(i18n('Given %1$s must be no longer than %2$s characters.'), alias(property), attributeValue);
  },
  length: function(property, propertyValue, attributeValue) {
    return i18nUtils.sprintf(i18n('Given %1$s must be exactly %2$s characters long.'), alias(property), attributeValue);
  },
  format: function(property, propertyValue, attributeValue) {
    return i18nUtils.sprintf(i18n('Given %1$s needs to be a valid %2$s format.'), alias(property), attributeValue);
  },
  type: function(property, propertyValue, attributeValue) {
    if (property.toLowerCase() === 'groupcode') {
      return i18n('Community must be selected.');
    }

    return i18nUtils.sprintf(i18n('Given %1$s needs to be a %2$s.'), alias(property), attributeValue);
  },
  pattern: function(property) {
    switch (property.toLowerCase()) {
      // Email address
      case 'email':
        return i18n('Enter the full email address, e.g. "john@email.com"');
      case 'body':
        return i18n('The body text cannot be blank.');
      case 'title':
        return i18n('The title must contain at least one letter.');
      case 'subject':
        return i18n('You need a subject line.');
      // Username
      case 'username':
        return i18n('Given username is not a valid format. Try only using letters, numbers, hyphens (-) and underscores (_)');
      case 'supportlink':
        return i18n('Enter a legal url like www.yoursite.com or http://www.yoursite.com');
      default:
        return i18nUtils.sprintf(i18n('The text for %1$s is in the wrong format. Please check and correct it.'), alias(property));
    }
  },
};



// WEBPACK FOOTER //
// ./app/assets/js/validationMessages.js